import React from 'react';

interface AuthShellProps {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

const HERO_IMAGE = `${process.env.PUBLIC_URL || ''}/kaaba-hero.jpg`;

/** Split-screen frame shared by the login pages */
const AuthShell: React.FC<AuthShellProps> = ({ icon: Icon, title, subtitle, children, footer }) => (
  <div className="min-h-screen bg-gray-50 rtl lg:grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)]">
    {/* Form side */}
    <div className="flex min-h-screen flex-col justify-between px-4 py-8 sm:px-8">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-900 text-gold-300">
          <Icon className="h-5 w-5" />
        </div>
        <div className="leading-tight">
          <p className="text-sm font-bold text-gray-900">مكتب الحرمين</p>
          <p className="text-xs text-gray-500">نظام إدارة الحج والعمرة</p>
        </div>
      </div>

      <div className="mx-auto w-full max-w-md py-10">
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-gray-900">{title}</h2>
          {subtitle && <p className="mt-2 text-gray-500">{subtitle}</p>}
        </div>
        {children}
      </div>

      <div className="text-center text-xs text-gray-400">
        {footer}
        <p>© {new Date().getFullYear()} مكتب الحرمين. جميع الحقوق محفوظة.</p>
        <p className="mt-1">تطوير: شركة وجهة لتقنية المعلومات</p>
      </div>
    </div>

    {/* Hero side */}
    <div className="relative hidden overflow-hidden lg:block">
      <img src={HERO_IMAGE} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-primary-950 via-primary-950/70 to-primary-900/30" />
      <div className="relative flex h-full flex-col justify-end p-12 text-white">
        <span className="badge mb-4 w-fit bg-gold-400/20 text-gold-200 ring-1 ring-inset ring-gold-300/30">
          حج · عمرة · زيارة
        </span>
        <h3 className="max-w-md text-4xl font-bold leading-snug">
          إدارة رحلاتك من الحجز حتى الوصول، في مكان واحد
        </h3>
        <p className="mt-4 max-w-md text-primary-100/80">
          الحجوزات والرحلات والباصات والتسكين والفواتير — بشكل منظم وواضح لفريقك وعملائك.
        </p>
      </div>
    </div>
  </div>
);

export default AuthShell;
